import { render } from "./ClientPaymentStatus.vue?vue&type=template&id=0d4ef6aa&ts=true"
import script from "./ClientPaymentStatus.vue?vue&type=script&lang=ts"
export * from "./ClientPaymentStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__